export function isImportMappingError(
  error: unknown,
): error is { name: string; message: string } {
  return (
    typeof error === 'object' &&
    error !== null &&
    'name' in error &&
    (error as any).name === 'ImportMappingError'
  );
}
